<input type="text" class="form-control" placeholder="Zoeken..." (input)="onSearch($event)" />